// eslint-disable-next-line import/prefer-default-export
export const setLanguage = (setDictData) => {
  const userLocale =
    navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
  let baseLocale;
  if (userLocale.indexOf('-') !== -1) {
    baseLocale = userLocale.substring(0, userLocale.indexOf('-'));
  } else {
    baseLocale = userLocale;
  }

  const loadLocale = (locale) => import(`../assets/languages/${locale}.json`);

  loadLocale(baseLocale)
    .then((output) => {
      setDictData(output);
    })
    .catch(() => {
      // CI or uncommon browser locales can fail to resolve a translation chunk.
      // Always fall back to English so the app renders instead of returning null indefinitely.
      loadLocale('en')
        .then((output) => {
          setDictData(output);
        })
        .catch((fallbackErr) => {
          // eslint-disable-next-line no-console
          console.error('Failed to load default language pack (en).', fallbackErr);
          // Last-resort: unblock app render with an empty dictionary.
          setDictData({});
        });
    });
};
